import i18n from "i18next";
import { ELocale } from "@/app/types/locale";

export const setAppLanguage = async (lang: ELocale): Promise<void> => {
  await i18n.changeLanguage(lang);
  localStorage.setItem("locale", lang);
};
